import React from 'react'
import { ModalClosed } from '~misc/icons';
import { Link } from "react-router-dom";
import { IconAlert, IconWarning, ModalSuccess } from "~misc/icons";

const ModalAction = ({ isOpen, onClose, title, sub, buttonOne, buttonTwo, linkOne, linkTwo, status, limite, titleClassName, buttonTwoClassName }) => {
  const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-50 z-[99999]' : 'hidden';
  const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 z-40' : 'hidden';

  const statusMap = {
    success: <ModalSuccess />,
    alert: <IconAlert />,
    warning: <IconWarning />,
  };

  return (
    <div className={modalClasses}>
      <div className="fixed inset-4 flex items-center justify-center">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button type='button' onClick={onClose} className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0">
              <ModalClosed />
            </button>
          </div>
          {status && (
            <>
              <span className="flex justify-center mb-2">
                {statusMap[status]}
              </span>
            </>
          )}
          <h3 className={titleClassName || 'font-bold text-4xl max-w-[500px] m-auto'}>{title} </h3>
          <h4 className='mt-2'>{sub}</h4>
          <div className="flex justify-center gap-3 mt-3">
          {!limite && (
                     <button onClick={linkOne} type='button' className='px-6 py-3 rounded bg-secundaria text-primaria font-bold  hover:bg-white hover:text-secundaria border-2 border-secundaria border-quartenaria transition duration-300 ease-in-out'>
                     {buttonOne}
                   </button>
          )}



            <button onClick={linkTwo} type='button' className={buttonTwoClassName || 'px-6 py-3 rounded border-2  border-quinaria  text-quinaria font-bold hover:bg-quinaria hover:text-white transition duration-300 ease-in-out'}>
              {buttonTwo}
            </button>

          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>

  );
};
export default ModalAction